// The debounced wrapper is callable with the original function's signature
// AND exposes a `cancel()` escape hatch (used by AppRouter.tsx's cleanup to
// flush the pending call before the resize listener is torn down).
type DebouncedFunction<Args extends unknown[]> = ((...args: Args) => void) & {
  cancel: () => void;
};

const debounce = <Args extends unknown[]>(
  fn: (...args: Args) => void,
  ms = 50
): DebouncedFunction<Args> => {
  let timeoutId: ReturnType<typeof setTimeout>;
  const debounced = function (this: unknown, ...args: Args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  } as DebouncedFunction<Args>;
  debounced.cancel = () => clearTimeout(timeoutId);
  return debounced;
};

export default debounce;
